(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buzzko-icons"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__bzIconsInit) return;
  window.__bzIconsInit = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var io = null;

  function cardOf(icon) {
    return icon.closest('[data-bz-card]') || icon.parentElement;
  }

  function play(icon, ms) {
    icon.classList.remove('is-active');
    void icon.getBoundingClientRect(); // restart animations
    icon.classList.add('is-active');
    clearTimeout(icon.__bzT);
    icon.__bzT = setTimeout(function () { icon.classList.remove('is-active'); }, ms);
  }

  function setup(root) {
    (root || document).querySelectorAll('[data-bz-icon]:not([data-bz-ready])').forEach(function (icon) {
      icon.setAttribute('data-bz-ready', '');
      if (canHover) {
        var card = cardOf(icon);
        card.addEventListener('mouseenter', function () { play(icon, 1800); });
        card.addEventListener('focusin', function () { play(icon, 1800); });
      } else if ('IntersectionObserver' in window) {
        if (!io) {
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) play(e.target, 2200);
            });
          }, { threshold: 0.6 });
        }
        io.observe(icon);
      } else {
        icon.classList.add('is-active');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
